<script>
    const born = new Date(1998, 7, 13);
    const currentDate = new Date();
    let age = currentDate.getFullYear() - born.getFullYear();
    if (currentDate.getMonth() < born.getMonth() || 
        (currentDate.getMonth() === born.getMonth() && 
        currentDate.getDate() < born.getDate())) {
        age--;
    }

</script>

<section id="about">
    <div id='container'>
        <!-- svelte-ignore a11y-img-redundant-alt -->
        <img id="header-image" src='https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Fpb-s-min.png?alt=media&token=5585ab16-fdf1-496c-b9c3-9cb9fb9519a4' alt="Picture of me">
        <div id='container-text'>
            <h1>About me</h1>
            <p id='body'>I'm a {age} year old app developer, living in Viborg.
                I started programming in 2019, while working as a factory worker.
                I wanted to make an app solving a problem, that I had, and I ended up learning Flutter using the Dart programming language.<br><br>
                I later learned Java and Kotlin, and I wanted to spend more time on getting better at programming, so I started studying AP in Computer Science in Copenhagen.<br><br>
                Ever since, I have gotten better and better, and now I feel very comfortable making beautiful apps.</p>
            <div class='list-item'>
                <p class='list-item-title'>From</p>
                <p class='list-item-value'>Horsens, Denmark</p>
            </div>
            <div class='list-item'>
                <p class='list-item-title'>Living in</p>
                <p class='list-item-value'>Viborg, Denmark</p>
            </div>
            <div class='list-item'>
                <p class='list-item-title'>Developing</p>
                <p class='list-item-value'>Beautiful apps</p>
            </div>
            <div class='list-item'>
                <p class='list-item-title'>Occupation</p>
                <p class='list-item-value'>Freelance App Developer</p>
            </div>
            <div class='list-item'>
                <p class='list-item-title'>Computer</p>
                <p class='list-item-value'>14-inch MacBook Pro with an M1 Pro</p>
            </div>
        </div>
    </div>
</section>


<style>
    #container {
        padding-left: 0%;
        padding-right: 5%;
        width: 100vw - 20%;
        height: calc(100vh - 80px);
        background-color: rgba(38, 97, 255, 0.1);
        display: flex;
        justify-content: start;
        align-items: center;
        border-top: 5px solid rgba(0, 0, 0, 0.9);
        border-bottom: 5px solid rgba(0, 0, 0, 0.9);
    }

    #container-text {
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    #header-image {
        width: 58%;
        height: 100%;
        margin-right: 5%;
        object-fit: cover;
        background-color: aquamarine;
        border-right: 5px solid rgba(0, 0, 0, 0.9);
    }

    .list-item {
        display: inline-flex;
        width: 100%;
    }

    .list-item-title {
        margin-right: 16px;
        color: rgba(40, 100, 160, 1);
        font-weight: bold;
    }

    .list-item-value {
        color: rgba(0, 0, 40, 0.8);
        font-weight: bold;
    }

    #body {
        margin-bottom: 16px;
        margin-top: 16px;
        line-height: 32px;
    }

    h1 {
        font-size: 48px;
        color: rgba(0, 20, 70, 1);
        margin-top: 24px;
        margin-bottom: 12px;
    }

    p {
        font-size: 18px;
        color: rgba(0, 0, 40, 0.7);
        margin-top: 11px;
        margin-bottom: 0px;
    }

    @media (max-width: 952px) {
        #container {
            display: block;
            flex-direction: column;
            margin: 0%;
            padding: 0%;
            width: 100vw;
            height: auto;
            padding-bottom: 96px;
        }
        #container-text {
            width: calc(100vw - 64px);
            padding-left: 32px;
            padding-right: 32px;
            padding-top: 48px;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        #header-image {
            width: 100vw;
            max-height: 20%;
            margin-right: 0%;
            background-color: aquamarine;
            border-right: none;
        }
    }

</style>